import KeycloakPlugin from './plugins/keycloak';

(async function main() {
  const kauth = new KeycloakPlugin({
    realm: 'meerkat',
    url: process.env.VUE_APP_ACCOUNTS_SERVICE_URL,
    clientId: process.env.VUE_APP_CLIENT_ID
  });

  import('./app').then(({ default: init }) => init(kauth));

  try {
    const loggedin = await kauth.init({
      onLoad: 'login-required',
      enableLogging: true,
      checkLoginIframe: false
    });

    if (loggedin) {
      kauth.onRefreshTokenExpired = () => {
        kauth.login();
      };
    }
  } catch (err) {
    if (err instanceof TypeError) {
      if (err.message.includes('kc.login')) {
        // Ignore Keycloak bug
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
}());
